<template>
  <!-- L'export est une seule requête : les étapes suivent son déroulement réel (envoi,
       traitement serveur jusqu'au premier octet, réception, mise en forme du CSV). -->
  <div v-if="steps.length" class="export-progress" aria-live="polite">
    <div class="export-progress__bar" :class="{ 'is-running': running && percent === null, 'is-determinate': running && percent !== null }">
      <div v-if="running && percent !== null" class="export-progress__fill" :style="{ width: percent + '%' }"></div>
    </div>
    <ol class="export-steps">
      <li v-for="step in steps" :key="step.key" class="export-step" :class="'is-' + step.state">
        <span class="export-step__icon">
          <i v-if="step.state === 'done'" class="fa fa-check"></i>
          <i v-else-if="step.state === 'error' || step.state === 'cancelled'" class="fa fa-times"></i>
        </span>
        <span class="export-step__label">{{ step.label }}</span>
        <span v-if="step.detail" class="export-step__detail">{{ step.detail }}</span>
      </li>
    </ol>
    <p class="export-elapsed">
      {{ running ? "Temps écoulé" : doneLabel }}
      <strong>{{ elapsedLabel }}</strong>
    </p>
  </div>
</template>

<script>
// Étapes d'un export CSV, pilotées par le mixin exportProgress
export default {
  name: "ExportProgress",
  props: {
    steps: { type: Array, required: true },
    running: { type: Boolean, default: false },
    elapsedLabel: { type: String, default: "" },
    // Avancement connu (0-100) : barre déterminée au lieu de la barre qui défile
    percent: { type: Number, default: null },
    // Pied du bloc une fois terminé (la facturation automatique s'en sert pour sa génération)
    doneLabel: { type: String, default: "Fichier généré en" },
  },
};
</script>

<style lang="scss" scoped>
@keyframes export-progress-slide {
  0% {
    left: -30%;
  }
  100% {
    left: 100%;
  }
}

@keyframes export-step-spin {
  to {
    transform: rotate(360deg);
  }
}

.export-progress {
  position: relative;
  overflow: hidden;
  margin-bottom: 16px;
  padding: 14px 14px 10px;
  background-color: #f8f8f9;
  border: 1px solid #e7eaec;
  border-radius: 3px;
}

// Barre en haut du bloc, tant que la requête tourne : qui défile, ou remplie selon l'avancement.
.export-progress__bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background-color: #1ab394;

  &.is-running {
    background-color: rgba(26, 179, 148, 0.15);

    &::after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      width: 30%;
      background-color: #1ab394;
      animation: export-progress-slide 1.2s ease-in-out infinite;
    }
  }

  &.is-determinate {
    background-color: rgba(26, 179, 148, 0.15);
  }
}

.export-progress__fill {
  height: 100%;
  background-color: #1ab394;
  transition: width 0.4s ease;
}

.export-steps {
  margin: 0 0 8px;
  padding: 0;
  list-style: none;
}

.export-step {
  display: flex;
  align-items: center;
  color: #aeb1b3;
  line-height: 1.4;

  & + .export-step {
    margin-top: 8px;
  }

  &.is-active {
    color: #3e4144;

    .export-step__icon {
      border-color: rgba(26, 179, 148, 0.25);
      border-top-color: #1ab394;
      animation: export-step-spin 0.8s linear infinite;
    }
  }

  &.is-done {
    color: #676a6c;

    .export-step__icon {
      border-color: #1ab394;
      background-color: #1ab394;
      color: #fff;
    }
  }

  &.is-cancelled {
    color: #676a6c;

    .export-step__icon {
      border-color: #aeb1b3;
      background-color: #aeb1b3;
      color: #fff;
    }
  }

  &.is-error {
    color: #ed5565;

    .export-step__icon {
      border-color: #ed5565;
      background-color: #ed5565;
      color: #fff;
    }
  }
}

// Pastille de 16 px : cercle vide (à venir), anneau qui tourne (en cours), coche (fait).
.export-step__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-right: 10px;
  border: 2px solid #d5d8da;
  border-radius: 50%;
  font-size: 8px;
}

.export-step__detail {
  margin-left: auto;
  padding-left: 10px;
  color: #999;
  white-space: nowrap;
}

.export-elapsed {
  margin: 0;
  padding-top: 8px;
  border-top: 1px solid #e7eaec;
  color: #999;

  strong {
    color: #3e4144;
    font-variant-numeric: tabular-nums;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Global/ExportProgress.vue